import { Signal } from '@preact/signals'

interface FormFieldProps {
  id: string
  label: string
  type: 'text' | 'password'
  value: Signal<string>
  placeholder: string
  disabled?: boolean
  helperText?: string
  helperLink?: {
    text: string
    href: string
  }
}

export function FormField({
  id,
  label,
  type,
  value,
  placeholder,
  disabled = false,
  helperText,
  helperLink,
}: FormFieldProps) {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-slate-300 mb-2">
        {label}
      </label>
      <input
        id={id}
        type={type}
        value={value.value}
        onInput={e => (value.value = e.currentTarget.value)}
        className="w-full px-4 py-2 bg-slate-700 border border-slate-600 rounded-md text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        placeholder={placeholder}
        disabled={disabled}
      />
      {helperText && (
        <p className="mt-2 text-sm text-slate-400">
          {helperText}
          {helperLink && (
            <>
              {' '}
              <a
                href={helperLink.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300"
              >
                {helperLink.text}
              </a>
            </>
          )}
        </p>
      )}
    </div>
  )
}
